<template>
    <div>
      <v-btn color="primary" dark class="mb-2 hbtn" to="/restaurants/store"
        >{{ $t("customers.restaurantsN.newRestaurant") }}</v-btn
      >
      <DataTable
        ref="restaurantDataTable"
        :url="api.ACTIONS.RESTAURANT"
        :titles="titles"
        :fields-hidden-add="['created_at', 'updated_at']"
        :title="$t('customers.restaurantsN.title')"
        :enableEdit="false"
        :enableAdd="false"
        :enableDelete="false"
        :add-rules="rules"
        :actions-extra-main="actionsExtraMain"
      />
    </div>
  </template>
  
  <style>
  .hbtn {
    float: right;
    z-index: 1;
    margin-top: 20px;
    margin-right: 20px;
    padding: 0px 45px;
  }
  </style>
  
  <script>
  import DataTable from "@/components/monaco/DataTable";
  import moment from "moment";
  import i18n from "@/i18n";
  
  const required = (val) =>
    (val !== null && val !== undefined) || i18n.t("customers.restaurantsN.requiredField");
  
  export default {
    name: "Restaurants",
    title() {
      return this.$t("customers.restaurantsN.title");
    },
    components: { DataTable },
    data() {
      return {};
    },
  
    computed: {
      rules() {
        return {
          name: [required],
        };
      },
      titles() {
        return {
          id: this.$t("customers.restaurantsN.id"),
          name: this.$t("customers.restaurantsN.name"),
          address: this.$t("customers.restaurantsN.address"),
          landmark: this.$t("customers.restaurantsN.landmark"),
        };
      },
      actionsExtraMain() {
        return {
          editRestaurant: {
            title: this.$t("customers.restaurantsN.editRestaurant"),
            icon: "edit",
            action: (item) =>
              this.$router.push({
                name: "EditRestaurant",
                params: { id: item.id },
              }),
          },
          deleteRestaurant: {
            title: this.$t("customers.restaurantsN.deleteRestaurant"),
            icon: "delete_forever",
            action: ({ id }) => {
              this.loading = true;
              this.axios
                .delete(`restaurant/${id}`)
                .then((res) => {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("customers.restaurantsN.deleted"),
                    "green"
                  );
                  this.$refs.restaurantDataTable.getData();
                })
                .catch((err) => {
                  let response = err.response;
                  if (response) {
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      response.data.message,
                      "red"
                    );
                  } else {
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      this.$t("customers.restaurantsN.somethingWentWrong"),
                      "red"
                    );
                  }
                })
                .finally(() => (this.loading = false));
            },
          },
        };
      },
    },
  };
  </script>
  